import { createFileRoute, redirect } from '@tanstack/react-router'

const URL_STORAGE_KEY = 'jobilla_pending_url'

export const fixProtocolSlashes = (path: string): string => {
	if (path.startsWith('https:/') && !path.startsWith('https://')) {
		return path.replace('https:/', 'https://')
	} else if (path.startsWith('http:/') && !path.startsWith('http://')) {
		return path.replace('http:/', 'http://')
	}
	return path
}

export const isUrl = (path: string): boolean => {
	return path.startsWith('http://') || path.startsWith('https://')
}

export const stripDomainPrefix = (path: string): string => {
	const domainPattern = /^https?:\/\/[^/]+\//
	if (domainPattern.test(path)) {
		return fixProtocolSlashes(path.replace(domainPattern, ''))
	}
	return path
}

export const processPath = (pathname: string): string => {
	let path = pathname.startsWith('/') ? pathname.slice(1) : pathname
	path = fixProtocolSlashes(path)
	return path
}

export const Route = createFileRoute('/$')({
	beforeLoad: ({ location }) => {
		const fullPath = processPath(location.pathname)

		if (fullPath && isUrl(fullPath)) {
			try {
				localStorage.setItem(URL_STORAGE_KEY, fullPath)
			} catch (error) {
				console.warn('Failed to save URL to localStorage:', error)
			}
		} else {
			console.log('[$.tsx] URL not stored - fullPath:', fullPath, 'isUrl:', isUrl(fullPath))
		}

		throw redirect({ to: '/auth' })
	},
})
